'use strict';

angular.module('imagetrend.components')
    .directive('hlpHtml', ['$compile', '$parse', function ($compile, $parse) {
        return {
            restrict: 'E',
            link: function (scope, element, attr) {
                scope.$watch(attr.content, function () {
                    element.html($parse(attr.content)(scope));
                    $compile(element.contents())(scope);
                }, true);

                scope.$on('$destroy', function () {
                    if (element) {
                        angular.element(element).off();
                        angular.element(element).remove();
                        element = null;
                    }
                });
            }
        };
    }])

;